import React, { Component } from 'react';
import './checkbox.styles.css';

class CheckBox extends Component {
  onKeyDown (event) {
    if (event.keyCode === 13) {
      event.target.checked = !this.props.checked;
      this.props.onChange(event);
    }
  }
  render () {
    this.checkRef =
      this.props.checkRef !== undefined
        ? this.props.checkRef
        : React.createRef();
    let css = 'checkmark';
    css +=
      this.props.checkmarkClassName !== undefined
        ? this.props.checkmarkClassName
        : '';

    return (
      <label className='container'>
        {this.props.label}
        <input
          type='checkbox'
          checked={this.props.checked}
          onChange={this.props.onChange}
          readOnly={this.props.readOnly}
          disabled={this.props.disabled}
        />
        <span
          className={css}
          onKeyDown={this.onKeyDown.bind(this)}
          tabIndex={this.props.tabIndex}
          ref={this.checkRef}
        ></span>
        {this.props.children && this.props.children}
      </label>
    );
  }
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/componentes/checkbox/checkbox.component.js